export const aimTagWithNoCommands = (apiKey: string, dataLayerName = "aimDataLayer") => {
    return `
window.${dataLayerName} = window.${dataLayerName} || [];
function aimTag(){${dataLayerName}.push(arguments);}
`
};
